import { UserConstants as Constants } from "../constants";
import { userApi as api } from "../../api";

export const userAction = {
  get,
  details,
  add,
  update,
  remove,
  clear,
};

function get(data, offset, limit) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._get(data, offset, limit).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.GET, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function details(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._details(id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.DETAILS, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function add(form_data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._add(form_data).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
    function success(payload) {
      return { type: Constants.ADD, payload };
    }
    function failure() {
      return { type: Constants.FAILED };
    }
  };
}

function update(form_data, id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._update(form_data, id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.UPDATE, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function remove(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._delete(id).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.DELETE, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function clear() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(success());
      resolve();
    });
  };
  function success() {
    return { type: Constants.CLEAR };
  }
}
